export default "__VITE_ASSET__2723b76d__"